"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletAPI = void 0;
var wallet_constants_1 = require("./wallet.constants");
var api_utils_1 = require("../../utils/api.utils");
var api_client_1 = __importDefault(require("../api-client"));
var WalletAPI = /** @class */ (function () {
    function WalletAPI() {
    }
    /**
    * @deprecated The method should not be used
    */
    WalletAPI.addWallet = function (wallet) {
        return api_client_1.default.post(wallet_constants_1.WALLET_API_URLS.ADD_WALLET, { wallet: wallet });
    };
    /**
    * @deprecated The method should not be used
    */
    WalletAPI.fetchWallet = function (owner) {
        return api_client_1.default.get((0, api_utils_1.replaceUrlParams)(wallet_constants_1.WALLET_API_URLS.LIST, { owner: owner }));
    };
    WalletAPI.add = function (address) {
        return api_client_1.default.post(wallet_constants_1.WALLET_API_URLS.ADD, { address: address });
    };
    WalletAPI.remove = function (address) {
        return api_client_1.default.post(wallet_constants_1.WALLET_API_URLS.REMOVE, { address: address });
    };
    WalletAPI.getWallets = function (login) {
        return api_client_1.default.post(wallet_constants_1.WALLET_API_URLS.GET_WALLETS, { login: login });
    };
    return WalletAPI;
}());
exports.WalletAPI = WalletAPI;
